<template>
  <main class="language-page">
    <header class="language-page__header">
      <button type="button" :aria-label="$t('frontend.common.back')" @click="back"><van-icon name="arrow-left" /></button>
      <h1>{{ $t('setting.language') }}</h1>
      <span></span>
    </header>
    <div class="language-page__items">
      <!-- 简体中文入口暂时隐藏，保留原代码，后续可取消注释恢复。
      <div
        class="language-page__item"
        @click="changeLang('zh')"
      >
        <div>
          <div>简体中文</div>
        </div>
        <div v-if="lang == 'zh'">✓</div>
      </div>
      -->
      <div
        class="language-page__item"
        @click="changeLang('en')"
      >
        <div>
          <div>English</div>
        </div>
        <div v-if="lang == 'en'">✓</div>
      </div>
      <div
        class="language-page__item"
        @click="changeLang('ja')"
      >
        <div>
          <div>日本語</div>
        </div>
        <div v-if="lang == 'ja'">✓</div>
      </div>
      <div
        class="language-page__item"
        @click="changeLang('kr')"
      >
        <div>
          <div>한국어</div>
        </div>
        <div v-if="lang == 'kr'">✓</div>
      </div>
      <div
        class="language-page__item"
        @click="changeLang('fr')"
      >
        <div>
          <div>Français</div>
        </div>
        <div v-if="lang == 'fr'">✓</div>
      </div>
      <div
        class="language-page__item"
        @click="changeLang('es')"
      >
        <div>
          <div>Español</div>
        </div>
        <div v-if="lang == 'es'">✓</div>
      </div>
    </div>
  </main>
</template>
<script>
import { setLanguage } from '../../i18n';
export default {
  name: "Language",
  data() {
    return {
      returnPath: '',
      changing: false
    };
  },
  computed: {
    lang() { return this.$i18n.locale; }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => { vm.returnPath = from.name && from.name !== 'Language' ? from.fullPath : ''; });
  },
  methods: {
    back() {
      if (this.returnPath) return this.$router.back();
      return this.$router.replace(localStorage.getItem('token') ? '/Mine' : '/Login');
    },
    async replaceLang(lang) {
      // The preference and every API language header already update locally.
      // Keep the legacy cookie in sync without delaying or undoing the switch.
      try {
        await this.$http({ method: 'get', url: 'replaceLang', data: { lang } });
      } catch (error) { /* The local preference remains usable while offline. */ }
    },
    changeLang(lang) {
      if (this.changing) return;
      this.changing = true;
      const language = setLanguage(lang);
      this.replaceLang(language);
      this.back();
    }
  }
};
</script>

<style scoped>
.language-page { min-height: 100vh; background: #f7f7fa; color: #16121c; }
.language-page__header { height: 3.3125rem; display: grid; grid-template-columns: 2.75rem 1fr 2.75rem; align-items: center; color: #fff; background: linear-gradient(105deg, #7f57dd, #c33b9c); }
.language-page__header button { height: 3.3125rem; border: 0; color: #fff; background: transparent; font-size: 1.3rem; }
.language-page__header h1 { margin: 0; color: #fff; font-size: 0.875rem; font-weight: 700; text-align: center; }
.language-page__items { padding: 0 0.875rem; background: #fff; }
.language-page__item { display: flex; min-height: 2.78rem; align-items: center; justify-content: space-between; border-bottom: 0.04rem solid #f0eef2; color: #141018; font-size: 0.94rem; font-weight: 700; }
.language-page__item:last-child { border-bottom: 0; }
.language-page__item > div:last-child { color: #7f3eb4; font-size: 1.1rem; }
</style>
